import { render, staticRenderFns } from "./TransformOrder.vue?vue&type=template&id=5b3cb48c&scoped=true"
import script from "./TransformOrder.vue?vue&type=script&lang=js"
export * from "./TransformOrder.vue?vue&type=script&lang=js"
import style0 from "./TransformOrder.vue?vue&type=style&index=0&id=5b3cb48c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3cb48c",
  null
  
)

export default component.exports